<script setup>
import { computed } from 'vue';
import { attentionState, countLabel } from './state';
defineProps({ collapsed: { type: Boolean, default: false } });
const count = computed(() => attentionState.snapshot?.counts?.outstanding_conversations || 0);
const open = event => window.dispatchEvent(new CustomEvent('attention:open', { detail: { focusPanel: event?.detail === 0 } }));
</script>
<template>
  <button v-if="attentionState.snapshot" class="attention-queue-badge" :class="{ collapsed }" :aria-label="`${count} conversations need attention. Open attention queue`" title="Outstanding conversations: unseen or awaiting your response" @click="open">
    <span aria-hidden="true">!</span><strong>{{ countLabel(count) }}</strong><span class="attention-queue-word">Attention</span>
  </button>
</template>
<style>
.attention-queue-badge { display:flex;align-items:center;justify-content:center;gap:6px;min-height:44px;min-width:44px;margin:6px 8px;padding:6px;border:1px solid #b42318;border-radius:8px;color:#8a1c13;background:#fff4ed;font-size:12px; }
.dark .attention-queue-badge { color:#ffdad6;background:#48201b;border-color:#ff9b8e; }
.attention-queue-badge:focus-visible { outline:3px solid #2563eb;outline-offset:2px; }
.dark .attention-queue-badge:focus-visible { outline-color:#93c5fd; }
.attention-queue-badge.collapsed .attention-queue-word { display:none; }
@media(max-width:900px) { .attention-queue-word { display:none; } }
</style>
